export default function getEnv(name) {
  const useEnvApiOnly = process.env.VUE_APP_USE_ENV_API_ONLY === 'true';
  let tmp;

  if (name === 'API_URL') {
    if (useEnvApiOnly) {
      tmp = process.env.VUE_APP_API_URL;
    } else {
      tmp = window?.configs?.API_URL || process.env.VUE_APP_API_URL;
    }
  } else {
    tmp = window?.configs?.[name] || process.env[name];
  }

  if (tmp === undefined || typeof tmp !== 'string') return tmp;

  const tmp2 = tmp.split(':');

  if (tmp2[0] === 'DYNAMIC') {
    const port = tmp2[1] == null || tmp2[1] == undefined ? '3000' : tmp2[1];

    return location.protocol + '//' + location.hostname + ':' + port + '/api';
  }

  return tmp;
}
